import {userRoles} from "./services/auth/userRoles";
import {AuthService} from "./services/auth/authService";

/**
 * Feature flag keys. Use these to reference a feature in {@link isFeatureEnabled}.
 */
const featureKeys = Object.freeze({
  downloadCustomerEmptiesBalanceExcel: "downloadCustomerEmptiesBalanceExcel",
});

/**
 * @typedef {Object} FeatureSetting
 * @property {string[]} roles - Roles that may access the feature.
 * @property {string[]} organizations - Organizations that may access the feature.
 */

/** @type {Object.<string, FeatureSetting>} */
const featureAccessSettings = {
  [featureKeys.downloadCustomerEmptiesBalanceExcel]: {
    roles: [userRoles.shipper, userRoles.administration],
    organizations: ["Zeit für Brot"],
  },
};

/**
 * Checks if a feature is enabled for the current user based on their role and organization.
 * @param {string} featureKey - The key of the feature to check; use values from {@link featureKeys}.
 * @param {string|null} orgName - The organization name to check against (used for administration access).
 *   When an admin has no org selected (null or empty), the feature is intentionally hidden.
 * @returns {boolean} True if the feature is enabled for the user, false otherwise.
 */
function isFeatureEnabled(featureKey, orgName = null) {
  const userRole = AuthService.getUserRole();
  // Admin can override the org from outside; empty/null orgName intentionally hides the feature for admins.
  const organization = userRole === userRoles.administration && orgName !== null
    ? orgName
    : AuthService.getUserOrganization();

  const feature = featureAccessSettings[featureKey];
  if (!feature) return false;

  return feature.roles.includes(userRole) && feature.organizations.includes(organization);
}

export {featureKeys, isFeatureEnabled};